var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"textbooks-index",attrs:{"tag":"section"}},[_c('navigation-tabs',{ref:"tabsElement",attrs:{"tabs":_vm.tabs}}),_c('router-view',{key:_vm.$route.params.textbookId})],1)}
var staticRenderFns = []

export { render, staticRenderFns }